import React, { useEffect, useState } from "react";
import { PageTitle } from "../../../_metronic/layout/core";
import { Card, Col, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { IAnalisisContexto, IFile, IGraveViolacion, ILocalizacion, IPersona, ISubcontexto } from "../Testimonial/EntrevistaIndividual/detallesTestimonio/testimonioModel";

export interface ITestimonio {
    _id: string;
    clasificacion: string;
    colectivo: string | null;
    duracion: string;
    emi: string;
    entidad: string;
    entrevistador: string;
    fecha: string;
    gravesViolaciones: IGraveViolacion[];
    grupoMilitancia: string;
    infoAdicional: string | null;
    lugar: string;
    materialAdicional: string;
    otrosFormatosTestimonios: string | null;
    persona: IPersona[];
    sesiones: string;
    subcontextos: ISubcontexto[];
    tipoEntrevista: string;
    tipoMaterialAdicional: string | null;
    tipoTestimoniante: string;
    tlaxcoaque: string;
    transcriptor: string;
    __v: number;
    files: IFile[];
    localizacion: ILocalizacion[];
    consecuencias: any[];
    sexo: string;
    causas: any[];
    factores: any[];
    analisisContexto: IAnalisisContexto[];
    estrategias: any[];
    ordenado: any[];
}

export interface IEtiquetas {
    nombre: string;
    hijos: any[];
}

const API_URL = process.env.REACT_APP_API_URL

const BusquedaFactores: React.FC = () => {

    const [entrevistas, setEntrevistas] = useState<ITestimonio[]>([]);
    const [etiquetas, setEtiquetas] = useState<IEtiquetas[]>([]);
    const [selectedEtiquetas, setSelectedEtiquetas] = useState<any[]>([])
    const auth = JSON.parse(localStorage.getItem("kt-auth-react-v")!);

    const updateFiltro = async (id: string) => {
        const updatedEtiquetas = [...selectedEtiquetas];
        const idIndex = updatedEtiquetas.indexOf(id);
    
        if (idIndex !== -1) {
            //console.log(`${id} is in the array.`);
            updatedEtiquetas.splice(idIndex, 1);
        } else {
            //console.log(`${id} is not in the array.`);
            updatedEtiquetas.push(id);
        }
    
        setSelectedEtiquetas(updatedEtiquetas);
        //console.log('Selected Etiquetas:', updatedEtiquetas);
    
        try {
            const response = await fetch(`${API_URL}/busquedaEtiquetas/filtroFactores`, {
                method: 'POST',
                body: JSON.stringify({ selectedEtiquetas: updatedEtiquetas }),
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': auth.api_token,
                },
            });
    
            if (response.ok) {
                const data = await response.json();
                setEntrevistas(data)
                //console.log(data);
            } else {
                console.error('API call failed');
            }
        } catch (error) {
            console.error('Error in API call:', error);
        };
    };

    const getEntrevistas = async () => {
        try {
            const response = await fetch(`${API_URL}/busquedaEtiquetas/getFactores`, {
                method: 'GET',
                headers: {
                    'auth-token': auth.api_token,
                }
            });
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            //console.log(data)
            setEntrevistas(data);
        } catch (err) {
            console.log(err);
        };
    }

    const getEtiquetas = async () => {
        try {
            const response = await fetch(`${API_URL}/etiqueta/getFactores`, {
                method: 'GET',
                headers: {
                    'auth-token': auth.api_token,
                }
            });
            if (response.ok) {
                const data = await response.json();
                setEtiquetas(data.data);
            }
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getEtiquetas();
        getEntrevistas();
    }, []);

    return (
        <>
            <PageTitle>Búsqueda por Etiquetas de Factores de Persistencia</PageTitle>
            <Row>
                {etiquetas.map((item: IEtiquetas, index) => (
                    <Col md={6} key={index}>
                        <strong>{item.nombre}</strong>
                        {item.hijos.map((post: { childId: string; checked: boolean; nombre: string, _id: string }, postIndex: number) => (
                            <Form.Check
                                key={post._id}
                                label={post.nombre}
                                onChange={() => updateFiltro(post._id)}
                                className='form-check form-switch form-check-custom form-check-solid py-1r'
                                checked={post.checked}
                            />
                        ))}
                    </Col>
                ))}

            </Row>
            <Row className="py-6">Número de resultados: {entrevistas!.length}</Row>
            <Row>
                {entrevistas!.map((post: ITestimonio) =>
                    <Col md="12" className="my-2" key={post.clasificacion}>
                        <Card>
                            <Card.Body>
                                <Card.Title><Link to={`/Testimonial/Detalles/${post._id}`}>{post.clasificacion} - {post.persona[0].nombre} ({post.tipoTestimoniante}) - {post.emi}</Link></Card.Title>
                                <div className="separator my-2"></div>
                                <Card.Body>
                                    <Row>
                                        <Col><strong>Lugar y Fecha:</strong> {post.entidad}, {moment(post.fecha).format('YYYY-MM-DD')}</Col>
                                        <Col><strong>Entrevistador(E)/Asistente(A):</strong> {post.entrevistador}</Col>
                                        <Col><strong>Transcriptor:</strong> {post.transcriptor}</Col>
                                        <Col><strong>Tipo de Entrevista:</strong> {post.tipoEntrevista}</Col>
                                    </Row>
                                    <Row>
                                        <Col><strong>Duración:</strong> {post.duracion}</Col>
                                        <Col><strong>Sesiones:</strong> {post.sesiones}</Col>
                                        <Col><strong>Material Adicional:</strong> {post.materialAdicional}</Col>
                                        <Col><strong>Tipo de Material Adicional:</strong> {post.tipoMaterialAdicional}</Col>
                                    </Row>
                                    <div className="separator my-2"></div>
                                    <Row>
                                        <Col>
                                            <h5>Análisis de Contexto</h5>
                                            {post.ordenado.map((element: any) => (
                                                <div key={element.id}>
                                                    <strong>{element.nombre}</strong>
                                                    <ul>
                                                        {element.children.map((child: any) => (
                                                            <li key={child._id}>{child.name}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ))}
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card.Body>
                        </Card>
                    </Col>
                )}
            </Row>
        </>
    )
}

export { BusquedaFactores };